/* generated by pull.js */
const now = new Date();
const manifest = {
  "noTranslations": true,
  "editorOnly": true,
  "name": "Christmas!",
  "description": "A fun christmas addon with snowflakes and Santa hats.",
  "credits": [
    {
      "name": "8to16"
    }
  ],
  "userscripts": [
    {
      "url": "default-project-loader.js"
    },
    {
      "url": "snowflakes.js"
    },
    {
      "url": "lights.js"
    },
    {
      "url": "hat.js"
    }
  ],
  "tags": [
    "theme",
    "new",
    "ob"
  ]
};

// Enable by default only on local dates Dec 23rd through Dec 26th (inclusive)
// `Date` uses the system's local time zone, so this matches the user's local date.
const month = now.getMonth(); // December === 11 (0-based months)
const day = now.getDate();
manifest.enabledByDefault = (month === 11 && day >= 23 && day <= 26);

export default manifest;
